var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
export function clamp(v, min, max) {
    return v < min ? min : v > max ? max : v;
}
export function num(props, key, fallback) {
    var v = props[key];
    return typeof v === 'number' ? v : fallback;
}
export function str(props, key, fallback) {
    if (fallback === void 0) { fallback = ''; }
    var v = props[key];
    return typeof v === 'string' ? v : fallback;
}
export function bool(props, key, fallback) {
    if (fallback === void 0) { fallback = false; }
    var v = props[key];
    return typeof v === 'boolean' ? v : fallback;
}
export function getState(node) {
    var _a;
    var state = (_a = node.metadata) === null || _a === void 0 ? void 0 : _a.widgetState;
    if (state && typeof state === 'object')
        return state;
    return {};
}
export function setState(node, patch) {
    node.metadata.widgetState = __assign(__assign({}, getState(node)), patch);
}
export function bindApp(node, app) {
    var e_1, _a;
    node._app = app;
    if ('children' in node) {
        try {
            for (var _b = __values(node.children), _c = _b.next(); !_c.done; _c = _b.next()) {
                var child = _c.value;
                bindApp(child, app);
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
    }
}
export function createWidgetGroup(app, type, props, extra) {
    if (extra === void 0) { extra = {}; }
    var w = num(props, 'width', 0) || num(props, 'size', 0);
    var h = num(props, 'height', 0) || num(props, 'size', 0);
    var merged = __assign(__assign({}, props), extra);
    // `scale` is Node's uniform transform. Dashboard widgets (e.g. battery) often pass
    // `scale` as a geometry multiplier — applying it here would double-scale and overflow.
    // Use scaleX/scaleY when a transform is intentional.
    var groupOpts = __assign({}, merged);
    if (!('scaleX' in groupOpts) && !('scaleY' in groupOpts)) {
        delete groupOpts.scale;
    }
    var group = app.group(__assign(__assign(__assign(__assign({}, groupOpts), { listening: true }), (w > 0 && h > 0 ? { clip: true } : {})), { metadata: __assign(__assign({ widgetType: type, widgetState: __assign({}, props) }, (w > 0 ? { chartWidth: w } : {})), (h > 0 ? { chartHeight: h } : {})) }));
    bindApp(group, app);
    setState(group, __assign({}, props));
    return group;
}
export function setRefresh(node, fn) {
    node.metadata.refresh = fn;
}
/** Animate a numeric widget value with optional refresh callback. */
export function animateLiveValue(node, key, toValue, duration) {
    if (duration === void 0) { duration = 400; }
    var app = node.getApp();
    if (!app)
        return;
    var from = num(getState(node), key, 0);
    var refresh = node.metadata.refresh;
    app.animate(node, {
        duration: duration,
        easing: 'easeOutCubic',
        onUpdate: function (progress) {
            var _a;
            var v = from + (toValue - from) * progress;
            setState(node, (_a = {}, _a[key] = v, _a));
            refresh === null || refresh === void 0 ? void 0 : refresh(v);
            app.requestRender();
        },
        onComplete: function () {
            var _a;
            setState(node, (_a = {}, _a[key] = toValue, _a));
            refresh === null || refresh === void 0 ? void 0 : refresh(toValue);
            app.requestRender();
        },
    });
}
export function setLiveValue(node, key, value) {
    var _a;
    var _b;
    setState(node, (_a = {}, _a[key] = value, _a));
    var refresh = node.metadata.refresh;
    refresh === null || refresh === void 0 ? void 0 : refresh(value);
    (_b = node.getApp()) === null || _b === void 0 ? void 0 : _b.requestRender();
}
export function dashboardToJSON(node) {
    var _a;
    var widgetType = (_a = node.metadata) === null || _a === void 0 ? void 0 : _a.widgetType;
    if (!widgetType)
        return node.toJSON();
    return {
        type: widgetType,
        id: node.id,
        props: __assign({ x: node.x, y: node.y }, getState(node)),
    };
}
export function getParts(node) {
    var _a;
    var parts = (_a = node.metadata) === null || _a === void 0 ? void 0 : _a._parts;
    return parts && typeof parts === 'object' ? parts : {};
}
export function setParts(node, parts) {
    node.metadata._parts = parts;
}
